import { Component, EventEmitter, Input, Output } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'
import { ButtonComponent } from '@shared/components/ui-kit/button/button.component'

@UseLocales({ ru, en })
@Component({
	selector: 'app-confirm-dialog',
	templateUrl: './confirm-dialog.component.html',
	styleUrl: './confirm-dialog.component.scss',
	imports: [TranslatePipe, ButtonComponent],
})
export class ConfirmDialogComponent {
	@Input() dialogTitle: string | null = null
	@Input() cancelText: string | null = null
	@Input() confirmText: string | null = null
	@Input() isLoadingConfirm: boolean = false

	@Output() onCancel: EventEmitter<void> = new EventEmitter<void>()
	@Output() onConfirm: EventEmitter<void> = new EventEmitter<void>()

	protected confirm(): void {
		this.onConfirm.emit()
	}

	protected cancel(): void {
		this.onCancel.emit()
	}
}
